import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import learningImg from "../../../assets/images/learning.png";
import { faUsers, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import moment from "moment";
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import { Box, LinearProgress } from "@mui/material";
import CustomTextLimit from "../../../assets/global-components/TextLimit";


const Sec8 = () => {


	const [modalShow, setModalShow] = useState(false);
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const navigate = useNavigate();

	const getWebinarsnEvents = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"shareholder_education",
			"fetchWebinarsnEvents",
			{
				type: "webinar",
				status: "true",
				is_home: true,
				limit: 3,
				page: 1
			},
			(res) => {
				setData(res?.data?.data?.shareholderss?.data)
				setIsLoading(false)
				// ToastAlertSuccess("Item removed Successfully");
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};

	useEffect(() => {
		getWebinarsnEvents();
	}, [])

	return (
		<>
			<section className='sec sec8'>
				<div className='container'>
					<div className="flex_btw">

						<h1 className="bold">Upcoming Webinars Events</h1>
						<button className="rounded_btn" onClick={() => navigate("/ShareHolderEducation/WebinarsandEvents")}>View More</button>
					</div>
					<div className="cards_wrap">
						<Container>
							<Row>

								{isLoading ?
									<Box sx={{ my: '5rem' }}>
										<LinearProgress color="success" />
									</Box>
									:
									data.map((e) => {
										return <>
											<Col xl={4} lg={6} md={6}>
												{/* <Card className="cards">
												<h4>{e.title}</h4>
												<h6><span className="bold">Date / Time: </span>{e.date}</h6>
												<div className="card-content">
													<h6><FontAwesomeIcon style={{ paddingRight: "10px" }} icon={faUsers} />{e.participants}</h6>
													<Button onClick={() => setModalShow(true)} className="card_btn" variant="primary">Register</Button>
												</div>
											</Card> */}
												<Card className="cards">
													<CustomTextLimit limit={50} title text={e?.title} />
													<CustomTextLimit text={e?.description} />
													<div className="card-content">
														<div>
															<h6 className="bold">Date / Time: </h6>
															<h6>{moment(e?.date).format("DD-MM-YYYY HH:mm")}</h6>
														</div>
														{/* <h6><FontAwesomeIcon style={{ paddingRight: "10px" }} icon={faUsers} />{e.participants}</h6> */}
														<Button onClick={() => window.open(e?.url?.startsWith('http') ? e.url : `https://${e.url}`, '_blank')} disabled={!e?.url} className="card_btn" variant="primary">Register</Button>
													</div>
												</Card>
											</Col>
										</>
									})}
							</Row>
						</Container>
					</div>


				</div>
			</section>


			{/* <Modal backdrop="static"
				centered
				dialogClassName="modal-90w"
				keyboard={false}
				show={modalShow}
				// onHide={() => setModalShow(false)}
				aria-labelledby="contained-modal-title-vcenter">
				<FontAwesomeIcon onClick={() => setModalShow(false)} fontSize={30} className="close_modal_icon" icon={faXmark} />
				<Modal.Header className="register_modal-bg modal_head_center" >
					<Modal.Title id="contained-modal-title-vcenter">
						Register Now
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: "5em" }} className="grid-example register_modal-bg">
					<Container>
						<Form>

							<Row>
								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupFName">
										<Form.Label>First Name</Form.Label>
										<Form.Control className="formInput" placeholder="First Name" />
									</Form.Group>

								</Col>

								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupLName">
										<Form.Label>Last Name</Form.Label>
										<Form.Control className="formInput" placeholder="Last Name" />
									</Form.Group>

								</Col>
							</Row>
							<Row>
								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupEmail">
										<Form.Label>Email</Form.Label>
										<Form.Control type="email" className="formInput" placeholder="Email" />
									</Form.Group>

								</Col>

								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupPhone">
										<Form.Label>Phone</Form.Label>
										<Form.Control className="formInput" placeholder="Mobile No" />
									</Form.Group>

								</Col>
							</Row>
							<Row>
								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupPassword">
										<Form.Label>Password</Form.Label>
										<Form.Control type="password" className="formInput" placeholder="Password" />
									</Form.Group>

								</Col>

								<Col xs={6} md={6}>

									<Form.Group controlId="formGroupCPassword">
										<Form.Label>Confirm Password</Form.Label>
										<Form.Control className="formInput" placeholder="Confirm Password" />
									</Form.Group>

								</Col>
							</Row>


						</Form>

					</Container>
				</Modal.Body>
				<Modal.Footer className="register_modal-bg">
					<button className="rounded_btn " onClick={() => setModalShow(false)}>Register</button>
				</Modal.Footer>
			</Modal> */}
		</>
	);
};

export default Sec8;
